import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import CouponSetTimeSlot from "./CouponSetTimeSlot";
import { LanguageConfig } from "config/CustomEnums";

const LinkedCouponTimeSlotSection = () => {
  const fieldName = "ticketCampaignTimeSlots"
  const { control } = useFormContext();
  const { fields: timeSlots, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });
  const addNewTimeSlotSection = () => {
    append({
      couponSet: {},
      translations: {
        [LanguageConfig.english]: {
          timeSlot: ""
        },
      }
    })
  }
  useEffect(()=> {
    if (timeSlots?.length > 0) {
      return
    }
    addNewTimeSlotSection()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (<>
    {timeSlots?.map((_, index, arr) =>
      <CouponSetTimeSlot
        fieldNamePrefix={`${fieldName}.${index}`}
        areaTitle={`Time slot #${index+1}`}
        removeAction={()=>{remove(index)}}
        hideDeleteButton={arr.length === 1}
      />
    )}
    <button
      className="btn-back-button-common content-add-button"
      type="button"
      onClick={() => {
        addNewTimeSlotSection()
      }}
    >
      {"Add time slot"}
    </button>
  </>)
}

export default LinkedCouponTimeSlotSection; 